const collection = {
  slug: "miuccia-prada-archive-guide",
  metaTitle:
    "ミウッチャ・プラダとは｜ナイロンと醜さの美学でPRADAを変えたデザイナー完全ガイド",
  metaDescription:
    "ミウッチャ・プラダとはどんなデザイナーか。PRADAを老舗革製品ブランドから知的ラグジュアリーへ導いた生い立ち、ナイロンバッグ、醜さの美学、代表作、Raf Simonsとの共同体制まで解説。プラダの魅力を初めて知るためのEnclopediaアーカイブガイドです。",
  metaKeywords:
    "ミウッチャプラダとは,Miuccia Prada,ミウッチャ プラダ,PRADAとは,プラダ どんなブランド,プラダ 歴史,プラダ ナイロン,PRADA ナイロン,プラダ ナイロンバッグ,プラダ 醜さの美学,プラダ ugly chic,プラダ 歴代デザイナー,ラフシモンズ プラダ,PRADA Raf Simons,プラダ アーカイブ,PRADA アーカイブ,プラダ レンタル,PRADA レンタル,enclopedia,アンクロペディア",
  canonicalPath: "/archive_collection/miuccia-prada-archive-guide",
  heroImage: "media/archive_fashion/archive6.png",
  heroImageAlt:
    "ミウッチャ・プラダのナイロンと醜さの美学を解説するEnclopediaアーカイブガイド画像",
  heroNumber: "06 / MIUCCIA PRADA",
  label: "ARCHIVE DESIGNER STUDY",
  title: "ミウッチャ・プラダとは。ナイロンと“醜さ”でラグジュアリーを変えた人",
  lead: "Miuccia Pradaのデザインを一言で表すなら、\nそれは“醜さの洗礼”だと思う。\n\nPRADAは、ただ美しいものを作るブランドではありません。\n本来なら安っぽく見えるナイロン、制服のような硬さ、少し野暮ったい色、どこか不穏なバランス。\nそれらがPRADAの文脈に置かれると、急に知的で、ラグジュアリーに見えてくる。\n\nミウッチャ・プラダは、価値の見え方そのものを変えたデザイナーです。",
  keywordLine: [
    "miuccia prada",
    "nylon luxury",
    "ugly chic",
    "intellectual fashion",
  ],
  thesis:
    "ミウッチャ・プラダの重要性は、ラグジュアリーを華やかに飾ったことではなく、“美しくないもの”を知的で欲望されるものへ変えた点にあります。",
  whyTitle: "なぜナイロンが、PRADAではラグジュアリーに見えるのか。",
  whyBody:
    "PRADA以前、ラグジュアリーといえば、上質な革、華やかな装飾、分かりやすい高級感が中心にありました。\nしかしミウッチャ・プラダは、その価値観を真正面からずらします。\n軍用や工業素材のような実用的なナイロンを、あえて高級メゾンの中心へ持ち込む。\n当時の価値観なら安っぽく見えてもおかしくない素材が、PRADAになると急に知的で、冷たく、都会的に見えてくる。\n\n置く場所や文脈が変わるだけで、価値の見え方まで変わる。\nその不思議さこそ、ミウッチャ・プラダのデザインの核心です。",
  pillars: [
    {
      number: "01",
      title: "NYLON AS LUXURY",
      text: "ミウッチャ・プラダは、ナイロンを単なる機能素材としてではなく、ラグジュアリーの価値観を揺さぶる素材として扱いました。高級とは何かを、素材から問い直したのです。",
    },
    {
      number: "02",
      title: "UGLY CHIC",
      text: "PRADAの魅力は、分かりやすい美しさではありません。少し野暮ったい色、違和感のある形、知的な冷たさ。その“美しくなさ”が、むしろ新しい魅力になります。",
    },
    {
      number: "03",
      title: "INTELLECTUAL BRAND BUILDING",
      text: "ミウッチャ・プラダは、老舗革製品ブランドだったPRADAを、知性、社会性、違和感を持つ現代的なラグジュアリーブランドへ導きました。",
    },
  ],
  readingTitle: "生い立ち、ナイロン、醜さの美学から読むミウッチャ・プラダ。",
  readingIntro:
    "ミウッチャ・プラダを理解するには、PRADAのバッグや三角ロゴだけを見るのでは不十分です。政治学、演劇、女性像への視線、工業素材、制服的な服、Raf Simonsとの対話まで含めて見ると、PRADAの奥行きが見えてきます。",
  observations: [
    {
      index: "01",
      title:
        "老舗革製品ブランドの後継者としてではなく、価値観を壊す人として現れた",
      text: "PRADAは1913年にミラノで創業した老舗ブランドです。\nもともとは上質な旅行用品や革製品を扱う店でした。\nミウッチャ・プラダは、その歴史を単に守ったのではありません。\nむしろ、ラグジュアリーとは革でなければならない、華やかでなければならない、分かりやすく高級でなければならない、という前提を疑いました。\n\nPRADAが面白いのは、伝統を持っているのに、伝統的な高級感に安住しなかったことです。",
    },
    {
      index: "02",
      title: "政治学と演劇の経験が、服に“考える余地”を与えた",
      text: "ミウッチャ・プラダは、単なるファッションデザイナーとしての経歴だけで語り切れない人物です。\n政治学を学び、演劇にも関わり、1970年代の社会的な空気の中で女性像や権力、日常の記号を見てきました。\nその背景が、PRADAの服に独特の知性を与えています。\n\nPRADAの服は、ただ着飾るためのものではありません。\nなぜこの色なのか、なぜこの素材なのか、なぜ少し変に見えるのか。\n着る側に考えさせる余白があります。",
    },
    {
      index: "03",
      title: "ナイロンは、安い素材ではなく“価値を反転させる装置”だった",
      text: "PRADAを語るうえで、ナイロンは避けて通れません。\n本来、ナイロンは軍用や工業用途を連想させる実用素材です。\n革やシルクのように、分かりやすく高級に見える素材ではありません。\n\nしかしミウッチャ・プラダは、そのナイロンをバッグや服に使い、PRADAの中心的な記号にしました。\n安っぽく見えるはずのものが、PRADAの文脈に置かれると知的で都会的に見える。\nこの価値の反転こそ、ミウッチャ・プラダの発明です。",
    },
    {
      index: "04",
      title: "“醜さの洗礼”としてのPRADA",
      text: "ミウッチャ・プラダのデザインは、分かりやすい美しさを提示しません。\nむしろ、最初は少し変に見えることがあります。\nくすんだ色、制服のような硬さ、野暮ったい柄、奇妙なシルエット。\n\nでも、その違和感を通過すると、急に美しく見えてくる。\nそれは、可愛い、綺麗、セクシーといった既存の基準ではなく、知性や批評性によって生まれる美しさです。\nだからPRADAは、“醜さ”を否定するのではなく、そこに新しい欲望を作りました。",
    },
    {
      index: "05",
      title: "代表作は、ナイロンバッグだけではない",
      text: "PRADAの代表作として最も分かりやすいのは、ナイロンバッグやバックパックです。\nしかしミウッチャ・プラダの重要性は、それだけではありません。\n1990年代のミニマルなプレタポルテ、制服的なシャツやスカート、知的で少し冷たいウィメンズ、三角ロゴを使った記号性、Miu Miuに見られるより個人的で歪んだ少女性。\n\nPRADAとMiu Miuは、どちらもミウッチャの感覚から生まれていますが、PRADAはより知的で制度的、Miu Miuはより個人的で感情的な側面が強く出ます。",
    },
    {
      index: "06",
      title: "Raf Simonsの参加で、PRADAは“一人の作者”から“対話するブランド”へ",
      text: "2020年、Raf SimonsがPRADAの共同クリエイティブ・ディレクターに就任します。\nこれは単なる有名デザイナーの加入ではありません。\nミウッチャ・プラダの知性、違和感、社会性に、Raf Simonsの構築性、ユースカルチャー、緊張感が加わった出来事です。\n\n現在のPRADAは、ミウッチャ一人の美学だけでなく、二人の対話によって更新されています。\nそれでも核にあるのは、普通の価値観を少しずらし、見慣れたものを別の欲望へ変えるPRADAらしさです。",
    },
    {
      index: "07",
      title: "なぜ今、ミウッチャ・プラダを読む意味があるのか",
      text: "現在のファッションでは、ロゴ、分かりやすい高級感、SNS映えする派手さが注目されやすい。\nその中でミウッチャ・プラダの服は、少し違う速度で存在しています。\nすぐに分かる服ではなく、時間をかけて分かる服。\n美しさより先に、違和感が来る服。\n\nだからこそ、アーカイブとしてPRADAを見る意味があります。\n昔のPRADAが今も新鮮に見えるのは、単なるトレンドではなく、価値の見え方そのものを変えたブランドだからです。",
    },
  ],
  quote:
    "ミウッチャ・プラダは、美しいものを作ったのではなく、美しく見える条件そのものを変えた。",
  perspectiveTitle:
    "Enclopediaは、PRADAを“高級ブランド”ではなく“価値観を変えたアーカイブ”として読む。",
  perspectiveCards: [
    {
      number: "01",
      title: "KNOWLEDGE",
      text: "ミウッチャ・プラダの生い立ち、ナイロン、醜さの美学、Raf Simonsとの共同体制まで整理し、PRADAがなぜ特別なのかを可視化します。",
    },
    {
      number: "02",
      title: "EXPERIENCE",
      text: "PRADAの魅力は、写真だけでは伝わりにくい素材感、色の違和感、シルエットの硬さにあります。実際に着ることで理解が深まります。",
    },
    {
      number: "03",
      title: "COMMUNITY",
      text: "PRADAを単なるバッグやロゴではなく、思想や文脈として読む人が集まることで、アーカイブファッションへの入口を広げます。",
    },
  ],
  experienceTitle:
    "PRADAは、読むだけではなく、着ることで違和感の輪郭が見える。",
  experienceBody:
    "PRADAの服は、画面上ではシンプルに見えることがあります。\nしかし実際に身体に乗せると、素材の硬さ、ナイロンの軽さ、色のくすみ、制服的な緊張感が立ち上がります。\nEnclopediaでは、アーカイブを所有物ではなく、ブランドの考え方を身体で辿るメディアとして扱います。",
  experienceItems: [
    "ナイロンやテクニカル素材の質感を実物で知る",
    "PRADAらしい色の違和感や硬さを体感する",
    "背景を読んだ後にレンタルで確かめる",
  ],
  archiveItemsTitle: "この思想を、実物で確かめる。",
  archiveItemsBody:
    "在庫導線には、ミウッチャ・プラダの美学と接続できる視点を添えます。単なる商品一覧ではなく、PRADAを理解する続きを設計します。",
  archiveItems: [
    {
      label: "ARCHIVE FOCUS 01",
      title: "Nylon as Luxury",
      productPath: "/product/7967fd73-d2e1-4907-a540-6ae5f7e49064",
      productImage:
        "media/product/1758032194.74034267967fd73-d2e1-4907-a540-6ae5f7e49064.jpg",
      text: "ナイロンやテクニカル素材を通して、PRADAがラグジュアリーの価値観をどのように変えたかを体験する導線。",
    },
    {
      label: "ARCHIVE FOCUS 03",
      title: "PRADA after Raf Simons",
      productPath: "/product/80a84e38-00e8-480c-ad70-829b65b538ac",
      productImage:
        "media/product/1749622842.489107680a84e38-00e8-480c-ad70-829b65b538ac.jpg",
      text: "ミウッチャ・プラダとRaf Simonsの対話によって更新された現在のPRADAを、実物で確認する導線。",
    },
  ],
};

export default collection;
